import * as _remapping3 from "@ampproject/remapping";
var _remapping2 = _remapping3;
try {
  if ("default" in _remapping3) _remapping2 = _remapping3.default;
} catch (e) {}
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = mergeSourceMap;
  function _remapping() {
    const data = _remapping2;
    _remapping = function () {
      return data;
    };
    return data;
  }
  function mergeSourceMap(inputMap, map, sourceFileName) {
    const source = sourceFileName.replace(/\\/g, "/");
    let found = false;
    const result = _remapping()(rootless(map), (s, ctx) => {
      if (s === source && !found) {
        found = true;
        ctx.source = "";
        return rootless(inputMap);
      }
      return null;
    });
    if (typeof inputMap.sourceRoot === "string") {
      result.sourceRoot = inputMap.sourceRoot;
    }
    return Object.assign({}, result);
  }
  function rootless(map) {
    return Object.assign({}, map, {
      sourceRoot: null
    });
  }
  0 && 0;

  //# sourceMappingURL=merge-map.js.map
  return exports;
}